<main class="min-h-screen bg-deep-green" style="font-family: var(--font-body);">
  <!-- ===== HERO SECTION ===== -->
  <section class="relative overflow-hidden pt-20 pb-24 md:pt-28 md:pb-36 border-b border-white/5">
    <!-- Top Gradient Bar -->
    <div class="absolute top-0 left-0 right-0 h-1.5 bg-gradient-to-r from-[#1B6B4A] via-[#C41E3A] to-[#D4A843]"></div>

    <!-- Decorative Elements -->
    <div class="absolute inset-0 overflow-hidden pointer-events-none">
      <div class="absolute -top-24 -right-24 w-96 h-96 rounded-full bg-white/[0.03] blur-3xl"></div>
      <div class="absolute bottom-0 left-1/4 w-[500px] h-[500px] rounded-full bg-[#1B6B4A]/[0.05] blur-[100px]"></div>
    </div>

    <div class="relative z-10 max-w-5xl mx-auto px-6">
      <!-- Institutional Header -->
      <div class="flex flex-col md:flex-row items-center md:items-start gap-8 mb-16 animate-in fade-in slide-in-from-top-4 duration-700">
        <!-- Logo -->
        <div class="flex-shrink-0 w-24 h-24 md:w-28 md:h-28 rounded-full border-[4px] border-white/20 overflow-hidden bg-white/5 flex items-center justify-center shadow-2xl ring-8 ring-white/5">
          <img src="/assets/icon/ancLogo.jpeg" alt="ANC Logo" class="w-full h-full object-cover" onerror="this.style.opacity='0.2'">
        </div>

        <!-- Branding Text -->
        <div class="flex-1 text-center md:text-left text-white">
          <h1 class="text-3xl md:text-4xl font-extrabold tracking-tight leading-tight mb-2" style="font-family: var(--font-heading);">
            ALL NIGERIA COMMUNITY GHANA
          </h1>
          <div class="space-y-1 text-white/70 text-sm md:text-base font-medium">
            <p class="flex items-center justify-center md:justify-start gap-2">
              <ng-icon name="lucideMapPin" class="text-gold" />
              22 Achimota-Legon Road, behind Pure Fire, Kisseman
            </p>
            <p class="flex items-center justify-center md:justify-start gap-2">
              <ng-icon name="lucidePhone" class="text-gold" />
              TEL: 024 484 4081
            </p>
          </div>
          <div class="mt-6 flex justify-center md:justify-start">
            <span hlmBadge variant="outline" class="text-[11px] md:text-xs font-bold tracking-[2px] uppercase text-gold border-gold/20 px-4 py-1.5 rounded-full shadow-inner bg-gold-light">
              One Nation, One People
            </span>
          </div>
        </div>
      </div>

      <!-- Hero Content -->
      <div class="text-center max-w-3xl mx-auto mt-12">
        <h2 class="text-4xl md:text-6xl font-black text-white mb-6 tracking-tight leading-[1.1]">
          Membership Registration <span class="text-gold">Portal</span>
        </h2>
        <p class="text-lg md:text-xl text-white/60 mb-12 leading-relaxed">
          Join the community today. Securely register your membership or track your existing application status with ease.
        </p>

        <!-- Main Actions -->
        <div class="flex flex-col sm:flex-row items-center justify-center gap-4">
          <button routerLink="/register" hlmBtn size="lg"
            class="w-full sm:w-auto  px-10 rounded-2xl bg-white text-[#0A3D2F] font-bold text-lg hover:bg-[#D4A843] hover:text-white transition-all duration-300 shadow-[0_20px_50px_rgba(0,0,0,0.3)] hover:-translate-y-1 active:translate-y-0">
            Start Registration
          </button>

          <button routerLink="/login" hlmBtn variant="outline" size="lg"
            class="w-full sm:w-auto h-8 px-10 rounded-2xl border-white/20 text-[#D4A843] font-bold text-lg hover:bg-white/5 hover:border-[#D4A843]/50 transition-all duration-300">
            Check Status
          </button>
        </div>
      </div>
    </div>
  </section>

  <!-- ===== PATH SELECTION ===== -->
  <section class="max-w-6xl mx-auto px-6 -mt-12 relative z-20 pb-24">
    <div class="grid grid-cols-1 md:grid-cols-2 gap-6">

      <!-- Registration Card -->
       <div hlmCard class="group p-6 overflow-hidden rounded-[2rem] bg-white border-0 shadow-2xl transition-all duration-500 hover:shadow-[#D4A843]/10">
        <!-- <div class="absolute top-0 right-0  text-[#D4A843]/10 group-hover:text-[#D4A843]/20 transition-colors duration-500">
          <ng-icon size="96" name="lucideUserPlus" />
        </div> -->
        <div hlmCardHeader class="relative  ">
          <div class="w-14 h-14 rounded-2xl bg-[#0A3D2F] flex items-center justify-center shadow-lg shadow-[#0A3D2F]/20 group-hover:scale-110 transition-transform duration-500">
            <ng-icon size="28" class="text-white" name="lucideUserPlus" />
          </div>
          <h3 hlmCardTitle class="text-2xl font-bold text-slate-900 ">New Membership</h3>
          <p hlmCardDescription class="text-slate-500 text-lg">Official registration process for new members</p>
        </div>
        <div hlmCardContent class=" ">
          <p class="text-slate-600 leading-relaxed">
            Follow our streamlined 5-step registration. Securely provide your data, upload documents, and settle your membership dues in minutes.
          </p>
        </div>
        <div hlmCardFooter class="">
          <button hlmBtn routerLink="/register" variant="ghost" class="group/btn  h-auto text-[#0A3D2F] font-bold text-lg hover:bg-transparent hover:text-[#1B6B4A] transition-colors">
            Get Started
            <ng-icon size="20" class="ml-2 transition-transform duration-300 group-hover/btn:translate-x-2" name="matArrowForwardOutline" />
          </button>
        </div>
      </div>

      <!-- Status Card -->
      <div hlmCard class="group p-6 overflow-hidden rounded-[2rem] bg-white border-0 shadow-2xl transition-all duration-500 hover:shadow-[#0A3D2F]/10">
        <!-- <div class="absolute top-0 right-0 p-8 text-[#0A3D2F]/5 group-hover:text-[#0A3D2F]/10 transition-colors duration-500">
          <ng-icon size="96" name="lucideCircleCheck" />
        </div> -->
        <div hlmCardHeader class="relative ">
          <div class="w-14 h-14 rounded-2xl bg-[#D4A843] flex items-center justify-center shadow-lg shadow-[#D4A843]/20 group-hover:scale-110 transition-transform duration-500">
            <ng-icon size="28" class="text-white" name="lucideSearch" />
          </div>
          <h3 hlmCardTitle class="text-2xl font-bold text-slate-900 ">Track Application</h3>
          <p hlmCardDescription class="text-slate-500 text-lg">Already applied? Stay updated on your progress</p>
        </div>
        <div hlmCardContent class="">
          <p class="text-slate-600 leading-relaxed">
            Enter your registration details to check if your membership has been approved or if further action is required from your end.
          </p>
        </div>
        <div hlmCardFooter class="">
          <button hlmBtn routerLink="/login" variant="ghost" class="group/btn h-auto text-[#D4A843] font-bold text-lg hover:bg-transparent hover:text-[#B0862A] transition-colors">
            Check Now
            <ng-icon size="20" class="ml-2 transition-transform duration-300 group-hover/btn:translate-x-2" name="matArrowForwardOutline" />
          </button>
        </div>
      </div>
    </div>
  </section>

  <!-- ===== PROCESS OVERVIEW ===== -->
  <section class="bg-slate-50 py-24 border-t border-slate-200">
    <div class="max-w-6xl mx-auto px-6">
      <div class="text-center mb-20">
        <span class="text-[#D4A843] font-bold tracking-[3px] uppercase text-sm mb-4 block">Workflow</span>
        <h2 class="text-3xl md:text-5xl font-black text-slate-900 mb-6">How it works</h2>
        <hlm-separator class="w-20 h-1.5 bg-[#0A3D2F] mx-auto rounded-full" />
      </div>

      <!-- Registration Steps -->
      <div class="grid grid-cols-1 md:grid-cols-5 gap-8">
        @for (item of registrationSteps; track $index) {
          <div class="relative group">
            <div class="flex flex-col items-center text-center">
              <div class="w-16 h-16 rounded-full bg-white border-2 border-slate-100 flex items-center justify-center text-[#0A3D2F] font-black text-xl shadow-xl group-hover:border-[#D4A843] transition-colors duration-300 relative z-10">
                {{ item.id }}
              </div>
              <h4 class="mt-6 font-bold text-slate-900">{{ item.title }}</h4>
              <p class="mt-2 text-sm text-slate-500 leading-relaxed">{{ item.description }}</p>
            </div>
            @if (!$last) {
              <div class="hidden md:block absolute top-8 left-1/2 w-full h-[2px] bg-slate-200 -z-0"></div>
            }
          </div>
        }
      </div>
    </div>
  </section>

  <!-- ===== FOOTER ===== -->
   <div class="max-w-7xl mx-auto px-6 bg-[#0A3D2F] text-white/80 pt-16 pb-8 border-t border-white/5 font-['Source_Sans_3'">
        <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
      <!-- Brand Section -->
      <div class="space-y-6">
        <div class="flex items-center gap-4">
          <div class="w-12 h-12 rounded-full border-2 border-white/20 overflow-hidden bg-white/5 flex items-center justify-center p-1">
            <img src="/assets/icon/ancLogo.jpeg" alt="ANC Logo" class="w-full h-full object-cover rounded-full">
          </div>
          <div>
            <h3 class="text-white font-bold tracking-tight text-lg leading-tight">ANC GHANA</h3>
            <p class="text-[10px] text-[#D4A843] font-bold tracking-[2px] uppercase">One Nation, One People</p>
          </div>
        </div>
        <p class="text-sm leading-relaxed text-white/60">
          The All Nigeria Community (ANC) Ghana is the umbrella body of all Nigerians resident in Ghana, dedicated to fostering unity and welfare.
        </p>
        <div class="flex gap-4">
          <!-- <a href="#" class="w-8 h-8 rounded-full bg-white/5 flex items-center justify-center hover:bg-[#D4A843] hover:text-[#0A3D2F] transition-all duration-300">
            <ng-icon name="lucideFacebook" size="16" />
          </a>
          <a href="#" class="w-8 h-8 rounded-full bg-white/5 flex items-center justify-center hover:bg-[#D4A843] hover:text-[#0A3D2F] transition-all duration-300">
            <ng-icon name="lucideTwitter" size="16" />
          </a>
          <a href="#" class="w-8 h-8 rounded-full bg-white/5 flex items-center justify-center hover:bg-[#D4A843] hover:text-[#0A3D2F] transition-all duration-300">
            <ng-icon name="lucideInstagram" size="16" />
          </a> -->
        </div>
      </div>

      <!-- Quick Links -->
      <div>
        <h4 class="text-white font-bold mb-6 text-sm uppercase tracking-widest">Navigation</h4>
        <ul class="space-y-4 text-sm">
          <li><a routerLink="/" class="hover:text-[#D4A843] transition-colors">Home</a></li>
          <li><a routerLink="/register" class="hover:text-[#D4A843] transition-colors">Membership Registration</a></li>
          <li><a routerLink="/login" class="hover:text-[#D4A843] transition-colors">Track Application</a></li>
          <li><a href="#" class="hover:text-[#D4A843] transition-colors">About ANC</a></li>
        </ul>
      </div>

      <!-- Resources -->
      <div>
        <h4 class="text-white font-bold mb-6 text-sm uppercase tracking-widest">Legal & Support</h4>
        <ul class="space-y-4 text-sm">
          <li><a href="#" class="hover:text-[#D4A843] transition-colors">Privacy Policy</a></li>
          <li><a href="#" class="hover:text-[#D4A843] transition-colors">Terms of Service</a></li>
          <li><a href="#" class="hover:text-[#D4A843] transition-colors">Contact Support</a></li>
          <li><a href="#" class="hover:text-[#D4A843] transition-colors">FAQs</a></li>
        </ul>
      </div>

      <!-- Contact Info -->
      <div class="space-y-6">
        <h4 class="text-white font-bold mb-6 text-sm uppercase tracking-widest">Contact Us</h4>
        <div class="space-y-4 text-sm">
          <div class="flex items-start gap-3">
            <ng-icon name="lucideMapPin" class="mt-1 text-[#D4A843]" />
            <p>22 Achimota-Legon Road,<br>behind Pure Fire, Kisseman</p>
          </div>
          <div class="flex items-center gap-3">
            <ng-icon name="lucidePhone" class="text-[#D4A843]" />
            <p>024 484 4081</p>
          </div>
          <div class="flex items-center gap-3">
            <ng-icon name="lucideMail" class="text-[#D4A843]" />
            <p>info&#64;ancghana.org</p>
          </div>
        </div>
      </div>
    </div>
   </div>


  <app-footer />
</main>
